export const ALERT_SETTINGS_TOGGLE_RIGHTPANEL = "alert-settings-toggle-rightpanel";
export const ALERT_SETTINGS_UPDATE_CHANNELS = "alert-settings-update-channels";
export const ALERT_SETTINGS_UPDATE_MANAGE = "alert-settings-update-manage";


// WEBPACK FOOTER //
// ./src/actions/alert-settings/types.tsx